<template>
    <div class="advance-dropdowns">
        <div class="field is-horizontal" v-if="isMobile">
            <div class="field-label is-normal">
                <label class="label">Select Brands</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select v-model="selectedBrand">
                                <optgroup label="JAPANESE BRANDS">
                                    <option v-for="brand in japaneseBrands" :value="brand">{{ brand.name }}</option>
                                </optgroup>
                                <optgroup label="OTHER BRANDS">
                                    <option v-for="brand in foreignBrands" :value="brand">{{ brand.name }}</option>
                                </optgroup>
                            </select>
                            <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="auction-drop-box" v-if="!isMobile">
            <div class="car-select-tabs" :class="[(!isMobile ? 'hide' : '')]" @click="expandSelect">{{ brand ?
                brand.name : 'Select Brands' }}
            </div>
            <div class="car-select-box box"
                 :class="[(isMobile ? 'is-wider' : ''), (isMobile && !expand ? 'hide' : '')]">
                <table class="table">
                    <tr>
                        <td class="is-category">JAPANESE BRANDS</td>
                    </tr>
                    <tr v-for="brand in japaneseBrands">
                        <td :class="{ 'is-primary' : isSelected(brand.name) }" @click="selectBrand(brand)">{{ brand.name
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="is-category">OTHER BRANDS</td>
                    </tr>
                    <tr v-for="brand in foreignBrands">
                        <td :class="{ 'is-primary' : isSelected(brand.name) }" @click="selectBrand(brand)">{{ brand.name
                            }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            selectedBrand: {
                get: function () {
                    return this.$store.getters.getJapaneseBrands
                },
                set: function (value) {
                    //this.brand = value;
                    if(value) {
                        this.$store.dispatch('handleQueryModelsStock', [])
                        this.$store.dispatch('setModelsToDefaultStock')
                        this.$store.dispatch('fetchBrandModelsByBrandIdStock', value.id)
                        this.$store.dispatch('changeQueryCompanyIdStock', value.name)
                        this.$store.dispatch('setChassisToDefaultStock')
                    }
                }
            },
            japaneseBrands() {
                return this.$store.getters.getJapaneseBrands
            },
            foreignBrands() {
                return this.$store.getters.getOtherBrands
            },
            isMobile() {
                return document.documentElement.clientWidth < 450
            }
        },
        data() {
            return {
                expand: false,
                brand: ''
            }
        },
        methods: {
            selectBrand(brand) {
                this.brand = brand;
                this.$store.dispatch('handleQueryModelsStock', [])
                this.$store.dispatch('setModelsToDefaultStock')
                this.$store.dispatch('fetchBrandModelsByBrandIdStock', brand.id)
                this.$store.dispatch('changeQueryCompanyIdStock', brand.name)
                this.$store.dispatch('setChassisToDefaultStock')
            },
            isSelected(brand) {
                return this.$store.getters.getAuctionSearchQueryStock["brand"] === brand
            },
            expandSelect() {
                this.expand = !this.expand;
            }
        }
    }
</script>

<style scoped>
    .box {
        height: 250px;
        width: 180px;
        overflow-y: auto;
    }

    .is-category {
        background-color: whitesmoke;
        font-weight: bold;
        color: #73aa00;
    }

    td {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        font-size: 14px !important;
        height: 15px !important;
        padding: 0px !important;
        font-weight: bold !important;
        max-width: 140px !important;
    }

    .is-wider {
        width: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/BrandStockCar.vue